'use client';

import { Check, Copy } from 'lucide-react';
import { useCallback, useState } from 'react';
import mergeClasses from 'shared/lib/utils';
import { Button } from '@/shared/ui/button';
export function Code({
  prefix,
  text,
  className
}: {
  text: string;
  prefix?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(text);
    setCopied(true);

    // setTimeout(() => {
    //   setCopied(false);
    // }, 3000);
  }, [text]);
  return <div className={mergeClasses('flex flex-row items-center justify-between h-10 bg-popover rounded-lg pl-4 pr-1 w-full overflow-hidden', className)} data-sentry-component="Code" data-sentry-source-file="code.tsx">
      <div className="flex items-center w-0 flex-1">
        {prefix && <p className="shrink-0 pr-1 text-body3">{prefix}</p>}
        <code className="text-body3 overflow-x-auto no-scrollbar whitespace-nowrap w-full block">
          {text}
        </code>
      </div>

      <Button type="button" className="relative transition-opacity duration-300 rounded-full hover:bg-popover shrink-0 ml-2" variant="ghost" size="icon" onClick={handleCopy} onMouseLeave={() => setCopied(false)} data-sentry-element="Button" data-sentry-source-file="code.tsx">
        <Check className={`absolute text-status-success transition-opacity ${copied ? 'opacity-100' : 'opacity-0'}`} size={16} data-sentry-element="Check" data-sentry-source-file="code.tsx" />
        <Copy className={`transition-opacity duration-500  ${copied ? 'opacity-0' : 'opacity-100'}`} size={16} data-sentry-element="Copy" data-sentry-source-file="code.tsx" />
      </Button>
    </div>;
}